// Copyright (c) 2025 DTCC and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { ServiceUpgradeConsent } from '@daml.js/dtc-registry-app/lib/Dtc/Registry/App/V3/Service/Upgrade';
import { useLedgerApiClient } from '../../../../contexts/LedgerApiContext';
import TemplateContract from '../../../../utils/TemplateContract';
import { useLedgerEnd } from '../../ledger/useLedgerEnd';

const useServiceUpgradeConsents: () => UseQueryResult<
  TemplateContract<ServiceUpgradeConsent>[],
  string
> = () => {
  const ledgerApi = useLedgerApiClient();
  const offset = useLedgerEnd();
  return useQuery({
    queryKey: ['queryServiceUpgradeConsents', offset, ledgerApi],
    queryFn: async () => {
      return ledgerApi.queryServiceUpgradeConsents(offset!);
    },
    enabled: !!offset,
    refetchInterval: false,
  });
};

export default useServiceUpgradeConsents;
